import { Link } from "react-router-dom";
import {
  ArrowRightIcon,
  QuestionMarkCircleIcon,
} from "@heroicons/react/24/outline";

import { answersPath, type KnowledgeBaseSubject } from "helpers/knowledge-base";

type KnowledgeBaseCalloutProps = {
  subject: KnowledgeBaseSubject;
  className?: string;
};

/**
 * Points a family at the answers page for their case or policy from wherever
 * they are in it. Shared because the case hub, the case timeline and the
 * policy pages all need it and none owns it.
 */
export default function KnowledgeBaseCallout({
  subject,
  className,
}: KnowledgeBaseCalloutProps) {
  return (
    <Link
      to={answersPath(subject)}
      className={`group flex items-center gap-4 rounded-xl border border-oat-200 bg-white p-5 shadow-sm transition-colors hover:border-cantelope ${
        className ?? ""
      }`}
    >
      <QuestionMarkCircleIcon
        className="h-6 w-6 shrink-0 text-plum"
        aria-hidden="true"
      />
      <div className="flex flex-col gap-0.5">
        <span className="font-serif text-lg leading-snug text-soil">
          Have a question?
        </span>
        <span className="text-base leading-snug text-evergreen/80">
          Take a look at the questions we hear most often.
        </span>
      </div>
      <ArrowRightIcon
        className="ml-auto h-5 w-5 shrink-0 text-evergreen transition-transform group-hover:translate-x-0.5"
        aria-hidden="true"
      />
    </Link>
  );
}
